import { render, staticRenderFns } from "./Van.vue?vue&type=template&id=176da30a&"
import script from "./Van.vue?vue&type=script&lang=ts&"
export * from "./Van.vue?vue&type=script&lang=ts&"
import style0 from "./Van.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports